import React, { Component } from 'react';
import { Col, Container, Row, Alert } from 'react-bootstrap';
import { ResourceContent } from '.';
import { getConfigurationDataKey, rawSafeHtmlProps } from '../utils';

interface ForgotPasswordAuthLayoutProps {
  image?: string | null;
  children: React.ReactNode;
}

export class ForgotPasswordAuthLayout extends Component<ForgotPasswordAuthLayoutProps> {
  render() {
    return (
      <Container fluid>
        <Row>
          <Col className='px-5 py-5 px-lg-5 py-lg-4 authlayout_custom_image px-md-0 py-md-0 mb-5 px-xs-0'>
            <div className='w-lg-50 mx-auto'>{this.props.children}</div>
          </Col>
          <Col className='d-flex justify-content-end px-5 py-5 px-lg-5 py-lg-4 authlayout_custom_image px-md-0 py-md-0 mb-5 px-xs-0'>
            <Alert variant='success' className='forgot-password-alert'>
              <p>
                <ResourceContent
                  contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                  sourceDataKey='content'
                  render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
                />
              </p>
              <p className='ms-2 mb-0 contact-label'>
                Phone:
                <span className='pl-4 pt-2 ms-1 contact-info'>
                  <ResourceContent
                    contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                    sourceDataKey='phone'
                    render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
                  />
                </span>
              </p>
              <p className='ms-2 mb-0 contact-label'>
                Fax:
                <span className='pl-4 pt-2 ms-4 contact-info'>
                  <ResourceContent
                    contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                    sourceDataKey='fax'
                    render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
                  />
                </span>
              </p>
              <p className='mb-0 mt-2'>
                <ResourceContent
                  contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                  sourceDataKey='hours'
                  render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
                />
              </p>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }
}

interface ForgotPasswordAuthLayoutHeaderProps {
  title: string;
  children: React.ReactNode;
}

export class ForgotPasswordAuthLayoutHeader extends Component<ForgotPasswordAuthLayoutHeaderProps> {
  static displayName = 'ForgotPasswordAuthLayoutHeader';

  render() {
    return (
      <div className='text-custom-50-new pb-2'>
        <h3 className='forgot-password-tittle'>{this.props.title}</h3>
        <h6 className='text-left mt-3'>{this.props.children}</h6>
      </div>
    );
  }
}
